import React from "react";
import PropTypes from "prop-types";
import { Button } from "arv-reactcomponents";

const BackButton = props => {
  const { previous, className } = props;
  if (previous) {
    return (
      <div className={`nw-backbtn-container ${className}`}>
        <Button onClick={previous} className="nw-backbtn-btn">
          <i className="icomoon-arrow_left nw-backbtn-ico" />
        </Button>
      </div>
    );
  }
  return null;
};

BackButton.defaultProps = {
  className: "",
  previous: PropTypes.func,
};

BackButton.propTypes = {
  className: PropTypes.string,
  previous: PropTypes.func,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: BackButton,
  component: BackButton,
};

export default ProjectComponent;
